import { useRef } from "react";
import { useForm } from "react-hook-form";
import moment from "moment";
import { useCreateOrderMutation } from "../../../../../../../../API/authApi";
import { useToastify } from "../../../../../../../../Hooks/hooks";
import { IPreOrderForm } from "../../../../../../../../Interfaces/formValue-interfaces";
import { INewOrder } from "../../../../../../../../Interfaces/request-interfaces";
import { IOrderParams, IPreOrderData, OrderTypes } from "../../../../../../../../Interfaces/componentTypes";
import useDialogHooks from "../../../../../../../../Components/Dialog/dialog-hooks";
import { IPreOrderProps } from "./preOrderDialog"
import useLanguagesHooks from "../../../../../../../../Components/Languages/setLanguage-hooks";
import OrderSuccess from "../OrderSuccess/orderSuccess";
import SmsCodeDialog from "../SMSCode/smsCodeDialog";
import { useOrderPayment } from "../../OrderPayment/useOrderPayment";

const usePreOrderHook = (props: IPreOrderProps) => {
    const { companyId, company_name, company_logo, company_contacts, cart, packageFee, totalPrice, pos_terminal, setDialog, onCloseDialog, setMainCart, totalItemCount, setContentType } = props;
    const [sendOrder, { isLoading: newOrderLoading }] = useCreateOrderMutation()
    const user_id = localStorage.getItem('user_id');
    const phone = localStorage.getItem('phone');
    const { open, onOpen: onOpenNoteDialog, onClose: onCloseNoteDialog } = useDialogHooks();
    const currentDate = new Date();
    const dialogRef = useRef<HTMLDivElement>(null);
    const normalizedPackageFee = Number(packageFee) || 0;
    const normalizedTotalPrice = Number(totalPrice) || 0;
    const totalCost = normalizedPackageFee + normalizedTotalPrice;
    const { t } = useLanguagesHooks();
    const { showToastError } = useToastify();

    const {
        register,
        control,
        formState: { errors },
        getValues,
        setValue,
        setError,
        watch,
    } = useForm<IPreOrderForm>({
        mode: 'onChange',
        defaultValues: {
            phone_number: phone ?? '',
            date: moment().format('YYYY-MM-DD'),
            time: undefined,
            notes: "",
            cash: true,
            card: false,
        },
    });

    const { getPaymentParams } = useOrderPayment(pos_terminal, setValue, watch, getValues);

    const handleNote = (note: string) => {
        setValue('notes', note.trim() || undefined);
        onCloseNoteDialog();
    };

    const onOrder = async () => {
        const phoneNumber = getValues('phone_number').trim().replace(/\s+/g, '');
        if (phoneNumber.length < 12) {
            setError("phone_number", { message: "dxgcghfhg" });
            dialogRef.current?.scrollTo({ top: 0, behavior: "smooth" });
            return;
        }
        if (!getValues('time')) {
            setError("time", { message: "dxgcghfhg" });
            return
        }
        const data: IPreOrderData = {
            cart: cart,
            packageFee: normalizedPackageFee,
            total_cost: totalCost,
        };
        const params: IOrderParams = {
            phone_number: phoneNumber,
            notes: getValues('notes'),
            date: getValues('date'),
            time: getValues('time'),
            ...getPaymentParams(),
            totalItems: totalItemCount,
            company_id: companyId,
            company_name: company_name,
            company_logo: company_logo,
            company_contacts: company_contacts
        };
        const payload: INewOrder = {
            company_id: companyId,
            order_type: OrderTypes.PREORDER,
            phone_number: phoneNumber,
            uuid: user_id,
            data: JSON.stringify(data),
            order_parameters: JSON.stringify(params)
        };

        try {
            const response = await sendOrder(payload).unwrap();
            setMainCart([]);
            setDialog(
                <OrderSuccess
                    setContentType={setContentType}
                    onClose={onCloseDialog}
                />)
        } catch (error: any) {
            const status = error?.error;
            if (status === 419) {
                setDialog(
                    <SmsCodeDialog
                        data={payload}
                        setDialog={setDialog}
                        setMainCart={setMainCart}
                        onCloseDialog={onCloseDialog}
                        setContentType={setContentType}
                    />
                )
            } else {
                showToastError(t('Toast.Error.Common'));
            }
        }
    };



    return {
        open,
        errors,
        control,
        dialogRef,
        totalCost,
        currentDate,
        newOrderLoading,
        onOrder,
        register,
        getValues,
        watch,
        handleNote,
        onOpenNoteDialog,
        onCloseNoteDialog,
    }
};

export default usePreOrderHook